import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      order: 1,
    },
    card: {
      '&:first-child:not(:only-child)': {
        marginBottom: SMALL_MARGIN,
      },
    },
    cardTitle: {
      color: colorsPalette.white,
      marginBottom: SMALL_MARGIN,
    },
    cardDescription: {
      lineHeight: 1.5,
      fontSize: 18,
      color: colorsPalette.gray,
    },
  }),
);

export default useStyles;
